// extracted by mini-css-extract-plugin
export default {"content":"OrdersListPage_content__o62g+","title":"OrdersListPage_title__di5y5","orange":"OrdersListPage_orange__qPdfV","actually_block":"OrdersListPage_actually_block__fynW-"};